import React from 'react';
import PropTypes from 'prop-types';
import Document from './../../components/document';
import messages from '../../text/messages';

class DocBug extends React.Component {
    render() {
        const { docType, adminId, docFormat } = this.props;
        const bugMessage = {
            pdf: messages.downloadPdf,
            xls: messages.downloadExcel,
            doc: messages.downloadWord,
            txt: messages.downloadText,
            jpg: messages.downloadImage,
            png: messages.downloadImage
        }[docFormat];

        return (
            <Document
                id={docType}
                docType={docType}
                view={{
                    showHeader: false,
                    component: 'icon-download',
                    bug: bugMessage
                }}
                ownerRole={{ id: adminId, type: 'admin' }}
            />
        );
    }
}

DocBug.defaultProps = {
    docFormat: 'pdf'
};
DocBug.propTypes = {
    docType: PropTypes.string.isRequired,
    adminId: PropTypes.string.isRequired,
    docFormat: PropTypes.string
};

export default DocBug;



// WEBPACK FOOTER //
// ./src/components/docBug/index.js